import styled, { withTheme } from 'styled-components';

const ToolNav = styled.ul`
    margin:0 0 30px 0;
    padding:0;
    list-style: none;
    li {
        margin:0 0 5px 0;
        padding:0;
    }

`;

export default withTheme(ToolNav);
